<template>
  <div class="sdk-docking">
    <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
      <el-tab-pane :label="this.$t('title.Wallet_generator')" name="walletCreationTool">
        <div class="item" style="margin-top: 30px">
          <el-button @click="createVallet">{{ $t('title.CreateWallet') }}</el-button>
          <div v-if="mnemonicWordsCreated">
            <div class="item">
              <label>{{ $t('title.Mnemonic') }}：</label>
              <span class="inline-block">{{mnemonicWordsCreated}}</span>
            </div>
            <div class="item">
              <label>{{ $t('title.Private_key') }}：</label>
              <span class="inline-block">{{privateKeyCreated}}</span>
            </div>
            <div class="item">
              <label>{{ $t('title.Public_key') }}：</label>
              <span class="inline-block">{{publicKeyCreated}}</span>
            </div>
            <div class="item">
              <label>{{ $t('title.address') }}：</label>
              <span class="inline-block">{{addressCreated}}</span>
            </div>
          </div>
        </div>
        <div style="margin-top: 80px">
          <div class="item">
            <label>{{ $t('title.Mnemonic_to_generate_private_key') }}</label>
            <el-input
              type="text"
              :placeholder="this.$t('title.Enter_the_mnemonic')"
              class="item-input"
              v-model="mnemonicWordsInput"
            />
            <el-button @click="getPrivateKeyFromMnemonicWords" class="item-btn">{{ $t('title.Sure') }}</el-button>
            <span class="inline-block">{{privateKeyTransformed}}</span>
          </div>
          <div class="item">
            <label>{{ $t('title.Private_key_export_public_key') }}</label>
            <el-input type="text" :placeholder="$t('title.Enter_private_key')" class="item-input" v-model="privateKeyInput" />
            <el-button @click="getPublicKeyFromPrivateKey" class="item-btn">{{ $t('title.Sure') }}</el-button>
            <span class="inline-block">{{publicKeyTransformed}}</span>
          </div>
          <div class="item">
            <label>{{ $t('title.Public_key_export_address') }}</label>
            <el-input type="text" :placeholder="$t('title.Enter_public_key')" class="item-input" v-model="publicKeyInput" />
            <el-button @click="getAddressFromPrivateKey" class="item-btn">{{ $t('title.Sure') }}</el-button>
            <span class="inline-block">{{addressTransformed}}</span>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('title.Method_call')" name="transferTool" v-if="isTestEnv">
        <div style="margin-top: 30px">
          <div class="item-2">
            <label>{{ $t('title.sig_type') }}：</label>
            <el-select
              v-model="selectConTem"
              :placeholder="this.$t('title.please_choose')"
              class="item-input"
              @change="sigChange"
            >
              <el-option
                v-for="item in optionConTem"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
              <!-- <el-option
                  label="XTO合约转账"
                  value="2">
              </el-option>
              <el-option
                  label="代质押"
                  value="3">
              </el-option>-->
            </el-select>
          </div>
          <div class="item-2">
            <label>{{ $t('title.RPC_service') }}：</label>
            <el-select v-model="rpcServerSelected" :placeholder="this.$t('title.please_choose')" class="item-input">
              <el-option
                v-for="(item, index) in rpcServerList"
                :key="index"
                :label="item.rpcUrl"
                :value="item.rpcUrl"
              ></el-option>
            </el-select>
          </div>
          <div class="item-2">
            <label>{{ $t('title.Chain_id') }}：</label>
            <el-input type="text" v-model="chainId" class="item-input" />
          </div>
          <div>
            <div class="item-2">
              <label>FromChainId：</label>
              <el-input type="text" v-model="fromChainId" class="item-input" />
            </div>
            <div class="item-2">
              <label>ToChainId：</label>
              <el-input type="text" v-model="toChainId" class="item-input" />
            </div>
            <div class="item-2">
              <label>From：</label>
              <el-input type="text" v-model="fromAddress" class="item-input" />
            </div>
            <div class="item-2" v-if="selectConTem == 1">
              <label>To：</label>
              <el-input type="text" v-model="toAddress" class="item-input" />
            </div>
            <div class="item-2" v-if="selectConTem != 1">
              <label>{{ $t('title.Contract_address') }}：</label>
              <el-input type="text" v-model="contractAddress" class="item-input" />
            </div>
          </div>
          <div class="item-2">
            <label>{{ $t('title.Transaction_amount') }}：</label>
            <el-input type="number" v-model="sendValue" class="item-input" />
          </div>
          <div class="item-2">
            <label>{{ $t('title.Private_key') }}：</label>
            <el-input
              :placeholder="$t('title.Please_enter0x')"
              type="text"
              v-model="privateKeyForTransfer"
              class="item-input"
            />
          </div>

          <div style="display:flex;">
            <div class="item-2" v-if="selectConTem != 1">
              <label>{{ $t('title.Contract_method') }}：</label>
              <el-select
                style="width: 250px;"
                v-model="contractFuncId"
                :placeholder="this.$t('title.please_choose')"
                @change="contractFnListChange"
              >
                <el-option
                  v-for="item in contractFnList"
                  :key="item.id"
                  :label="item.funcName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div class="item-2" style="display:flex;margin-left:28px" v-if="funcParam">
              <label style="padding-top:10px">{{ $t('title.Method_entry') }}：</label>
              <div>
                <div
                  v-for="(item, index) in funcParam.split(',')"
                  :key="item"
                  style="margin-bottom:10px"
                >
                  <label style="display:inline-block;width:100px;">{{item.split(':')[1]}}：</label>
                  <el-input
                    v-model="param[index]"
                    type="primary"
                    style="width: 100px;margin-right:10px;"
                    :placeholder="item.split(':')[0]"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
          <div style="margin: 20px">
            <el-button @click="createSig" :loading="btnLoading">{{ $t('title.Generate_sig') }}</el-button>
            <el-button @click="sendSig" :loading="btnLoading">{{ $t('title.Send_sig_transaction') }}</el-button>
          </div>
        </div>
        <div style="width: 100%;margin-bottom: 30px;margin-top: 40px">
          <div class="layout">
            <div class="setting">
              <ul>
                <li>
                  <label>{{ $t('title.theme') }}</label>
                  <select v-model="theme">
                    <option value>{{ this.$t('title.default') }}</option>
                    <option value="one-dark">one-dark</option>
                    <option value="vs-code">vs-code</option>
                  </select>
                </li>
                <li>
                  <label>{{ $t('title.Collapse_all') }}</label>
                  <select v-model="closed">
                    <option :value="false">false</option>
                    <option :value="true">true</option>
                  </select>
                </li>

                <li>
                  <label>deep</label>
                  <select v-model="deep">
                    <option v-for="item in 10" :value="item">{{item}}</option>
                  </select>
                </li>
                <li>
                  <label>font-size</label>
                  <select v-model="fontSize">
                    <option v-for="item in 10" :value="item+11">{{item+11}}</option>
                  </select>
                </li>
                <li>
                  <label for="line-height">line-height</label>
                  <select v-model="lineHeight">
                    <option v-for="item in 20" :value="item*2+14">{{item*2+14}}</option>
                  </select>
                </li>
              </ul>
            </div>
          </div>
          <div class="content">
            <jsonView
              :data="signParams"
              :theme="theme"
              :deep="deep"
              :iconStyle="iconStyle"
              :fontSize="fontSize"
              :lineHeight="lineHeight"
              :closed="closed"
              :iconColor="iconColor"
            />
          </div>
        </div>

        <div class="transfer-table" style="width: 100%;margin-bottom: 30px;margin-top: 40px">
          <div style="text-align: right">
            <el-button @click="getTransferList" type="primary">{{ $t('title.refresh_the_list') }}</el-button>
          </div>
          <el-table
            :data="transferTableData"
            height="520"
            border
            style="width: 100%;margin-bottom: 30px;margin-top: 10px"
            :header-cell-style="this.tableHeaderColor"
            v-loading="tableLoading"
          >
            <el-table-column :label="this.$t('title.Serial_number')" fixed align="center" width="90">
              <template slot-scope="scope">
                <span>{{scope.row.id}}</span>
              </template>
            </el-table-column>
             <el-table-column label="hash" width="400" align="center">
              <template slot-scope="scope">
              <el-link
                  @click="$refs.searchHash.open(scope.row.hash, scope.row.rpcServer, scope.row.fromChainId)"
                  :underline="false"
                  type="primary"
                >{{scope.row.hash}}</el-link>
              </template>
            </el-table-column>
            <el-table-column :label="this.$t('title.RPC_service')" width="200" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.rpcServer}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="this.$t('title.Chain_id')" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.fromChainId}}</span>
              </template>
            </el-table-column>
            <!--                <el-table-column-->
            <!--                        label="转账方名称"-->
            <!--                        align="center">-->
            <!--                    <template slot-scope="scope">-->
            <!--                        <span>{{scope.row.fromAddress}}</span>-->

            <!--                    </template>-->
            <!--                </el-table-column>-->
            <el-table-column :label="this.$t('title.Transfer_address')" width="400" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.fromAddress}}</span>
                <br />
                <span>{{to_32_decimal(scope.row.fromAddress)}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="this.$t('title.Amount_before_transfer')" width="150" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.fromBeforeCoins}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="this.$t('title.Amount_after_transfer')" width="150" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.fromAfterCoins}}</span>
              </template>
            </el-table-column>
            <!--                <el-table-column-->
            <!--                        label="收款方名称"-->
            <!--                        align="center">-->
            <!--                    <template slot-scope="scope">-->
            <!--                        <span>{{timestampToTime(scope.row.createTime)}}</span>-->
            <!--                    </template>-->
            <!--                </el-table-column>-->
            <el-table-column :label="this.$t('title.Payee_address')" width="400" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.toAddress}}</span>
                <br />
                <span>{{to_32_decimal(scope.row.toAddress)}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="this.$t('title.Amount_before_payment')" width="150" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.toBeforeCoins}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="this.$t('title.Amount_after_receipt')" width="150" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.toAfterCoins}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="this.$t('title.amount')" width="150" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.coins}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="this.$t('title.Gas_fee')" width="150" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.gasFee}}</span>
              </template>
            </el-table-column>
            
            <el-table-column :label="this.$t('title.time')" width="250" align="center">
              <template slot-scope="scope">
                <span>{{timestampToTime(scope.row.createTime)}}</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" :label="$t('title.state')" width="150" align="center">
              <template slot-scope="scope">
                 <span>{{ scope.row.status==-1? $t('title.Sent_awaiting_verification') :scope.row.status==-1? $t('title.failure') : $t('title.success') }}</span>
              </template>
            </el-table-column>
          </el-table>
          <!-- 交易查询结果 -->
         <SearchHash ref="searchHash" />
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('title.SDK_download')" name="sdkDownload" v-if="isTestEnv">
        <div>
          <div class="caption">{{ $t('title.Read_before_downloading') }}</div>
          <p>
            {{ $t('title.Read_before_downloading1') }}&nbsp;&nbsp;
            <a
              href="https://nodejs.org/en/"
              target="_blank"
            >https://nodejs.org/en/</a>
          </p>
          <p>{{ $t('title.Read_before_downloading2') }}&nbsp;&nbsp;npm install -g @vue/cli</p>
          <p>
            {{ $t('title.Read_before_downloading3') }}
            <a
              href="http://qiniu.thinkey.xyz/sdk/wallet-sdk-1.0.5.zip"
              download="wallet-sdk-1.0.5"
            >{{ $t('Read_before_downloading_Download SDK (1.0.5)') }}</a>
          </p>
          <p>{{ $t('title.Read_before_downloading4') }}</p>
          <p>{{ $t('title.Read_before_downloading5') }}</p>
          <p>{{ $t('title.Read_before_downloading6') }}</p>
        </div>
        <div>
          <div class="caption">{{ $t('title.Project_file_description') }}</div>

          <img src="../../assets/images/demo-des.png" style="width: 600px; height: auto" />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { demoFunction } from "../../utils/common";
import BigNumber from "bignumber.js";
import sdkApi from "../../api/sdkApi";
import SearchHash from '@/components/SearchHash'
import jsonView from '../../components/json-view';
import {
  sendTxSig,
  transferList,
  getContractFnList,
  contractList,
  getTransactionByHash,
} from "../../api/interface";
import _ from "lodash";
var abi = require("ethereumjs-abi");
// var util = require('ethereumjs-util');

export default {
  components: { SearchHash, jsonView },
  data() {
    return {
      activeTabName: "walletCreationTool",
      mnemonicWordsCreated: "",
      privateKeyCreated: "",
      publicKeyCreated: "",
      addressCreated: "",
      mnemonicWordsInput: "",
      privateKeyTransformed: "",
      privateKeyInput: "",
      publicKeyTransformed: "",
      publicKeyInput: "",
      addressTransformed: "",
      chainId: "1",
      fromChainId: "1",
      toChainId: "1",
      fromAddress: "",
      toAddress: "",
      sendValue: "",
      contractAddress: "",
      rpcServerList: [
        {
          createTime: 0,
          description: "测试",
          id: 10000,

          rpcUrl: "rpctest.thinkium.org",
          updateTime: 0
        },
        {
          createTime: 0,
          description: "官方",
          id: 10001,
          rpcUrl: "rpcproxy.thinkium.org",
          updateTime: 0
        }
      ],
      rpcServerSelected: "",
      privateKeyForTransfer: "",
      contractSelected: "",
      signParams: {},
      interval: null,
      intervalTime: 0,
      theme: "",
      fontSize: 14,
      lineHeight: 24,
      deep: 3,
      iconStyle: "square",
      closed: false,
      color1: "",
      color2: "",
      transferTableData: [],
      btnLoading: false,
      pageLoading: null,
      tableLoading: false,
      funcParam: "",
      param: [],
      contractFuncId: "",
      contractFnList: [],
      selectConTem: "",
      optionConTem: [],
      hahsDialogVisible: false,
      returnHash: '',
    };
  },
  computed: {
    iconColor() {
      const { color1, color2 } = this;
      if (color1 && color2) {
        return [color1, color2];
      } else {
        return [];
      }
    },
    isTestEnv(){
      const host = location.host;
      return ['localhost', 'test'].some(item => host.includes(item));
    }

  },
  created() {
    this.getTransferList();
    //获取合约模板
    this.getContractList();
  },
  methods: {
    handleTabClick() {},
    async createVallet() {
      this.mnemonicWordsCreated = await demoFunction.createMnemonicWords();
      this.privateKeyCreated = await demoFunction.getPrivateKeyFromMnemonicWords(
        this.mnemonicWordsCreated
      );
      this.publicKeyCreated = demoFunction.getPublicKeyFromPrivateKey(
        this.privateKeyCreated
      );
      this.addressCreated = demoFunction.getAddressFromPublicKey(
        this.publicKeyCreated
      );
    },

    async getPrivateKeyFromMnemonicWords() {
      this.privateKeyTransformed = await demoFunction.getPrivateKeyFromMnemonicWords(
        this.mnemonicWordsInput
      );
    },

    getPublicKeyFromPrivateKey() {
      this.publicKeyTransformed = demoFunction.getPublicKeyFromPrivateKey(
        this.privateKeyInput
      );
       console.log(this.publicKeyTransformed, 90000)
    },

    getAddressFromPrivateKey() {
      this.addressTransformed = demoFunction.getAddressFromPublicKey(
        this.publicKeyInput
      );
    },
    //获取合约模板
    getContractList() {
      contractList().then(response => {
        if (response.code == 200) {
          this.optionConTem = response.data;
          this.optionConTem.unshift({ id: 1, name: "普通转账" });
          this.selectConTem = this.optionConTem[0].id;
          this.constructorParam =
            response.data && response.data[0].constructorParam;
        } else {
          this.optionConTem = [];
          this.$message.error(response.msg);
        }
      });
    },

    //获取合约方法列表
    getContractFnLists(contractId) {
      getContractFnList({ contractId }).then(res => {
        this.contractFnList = res.data;
        this.funcParam = _.get(res.data[0], "funcParam", "");
        this.contractFuncId = _.get(res.data[0], "id", "");
      });
    },

    //sig类型切换
    sigChange() {
      if (this.selectConTem == 1) {
        this.funcParam = ""; //普通转账不传入方法和参数
      } else {
        this.getContractFnLists(this.selectConTem);
      }
    },
    //合约方法切换时
    contractFnListChange() {
      const data = this.contractFnList.find(v => v.id == this.contractFuncId);
      this.funcParam = data.funcParam;
    },
    createSig() {
      if (!this.rpcServerSelected) {
        this.$message.warning("请选择RPC服务");
        return;
      }
      if (!this.chainId) {
        this.$message.warning("请填写链ID");
        return;
      }
      if (!this.fromChainId) {
        this.$message.warning("请填写链fromChainId");
        return;
      }
      if (!this.toChainId) {
        this.$message.warning("请填写链toChainId");
        return;
      }
      if (!this.fromAddress) {
        this.$message.warning("请填写链from钱包地址");
        return;
      }
      if ( this.selectConTem == 1 && !this.toAddress) {
        this.$message.warning("请填写链to钱包地址");
        return;
      }
      if (!this.sendValue) {
        this.$message.warning("请填写交易金额");
        return;
      }
      if (!this.privateKeyForTransfer) {
        this.$message.warning("请填写私钥");
        return;
      }
      if (this.selectConTem != 1 && !this.contractAddress ) {
        this.$message.warning("请填写合约地址");
        return;
      }

      let data = {
        businessId: "1",
        url: this.rpcServerSelected,
        chainId: this.chainId,
        address: this.fromAddress
      };
      this.btnLoading = true;
      sdkApi
        .getAccount(data)
        .then(response => {
          if(this.privateKeyForTransfer.substr(0,2) != '0x') {
            this.privateKeyForTransfer = '0x' + this.privateKeyForTransfer
          }
          if (this.selectConTem == "1") {
            let nums = this.sendValue.trim();
            let valueNum = new BigNumber(`${nums}`).multipliedBy("1e+18");
            let obj = {
              chainId: this.chainId.toString(),
              fromChainId: this.fromChainId.toString(),
              toChainId: this.toChainId.toString(),
              from: this.fromAddress.toLowerCase(),
              to: this.toAddress.toLowerCase(),
              nonce: response.data.nonce.toString(),
              value: '0x' + valueNum.toString(10),
              input: ""
            };
            console.log('--paramsBeforeSig',obj)
            let signParams = demoFunction.signTransaction(
              obj,
              this.privateKeyForTransfer
            );
            console.log("signParams", signParams);
            this.signParams = signParams;
          } else {
            let funName = this.contractFnList.find(
              v => v.id == this.contractFuncId
            ).funcName;
            let outparam = this.contractFnList.find(
              v => v.id == this.contractFuncId
            ).funcOutParam;
            let paramArr = [];
            for (let item of this.funcParam.split(",")) {
              paramArr.push(item.split(":")[0]);
            }
            paramArr = `${funName}(${paramArr.join(",")}):(${outparam})`;

            let nums = this.sendValue.trim();
            let valueNum = new BigNumber(`${nums}`).multipliedBy("1e+18");
            this.param.forEach((v, index, arr) => {
              arr[index] = arr[index].replace(/\s*/g, "");
            });
            let encoded = abi.simpleEncode(paramArr, ...this.param);
            console.log(paramArr, 222222222222222222)
            console.log(...this.param, 1111111111111111111)
            let obj = {
              chainId: this.chainId.toString(),
              fromChainId: this.fromChainId.toString(),
              toChainId: this.toChainId.toString(),
              from: this.fromAddress.toLowerCase(),
              to: this.contractAddress.toLowerCase(),
              nonce: response.data.nonce.toString(),
              value: valueNum.toString(10),
              input: '0x' + encoded.toString("hex"),
              extra: new Buffer.from(JSON.stringify({gas:6000000})).toString('hex')
            };
            console.log('--paramsBeforeSig',obj)
            let signParams = demoFunction.signTransaction(
              obj,
              this.privateKeyForTransfer
            );
            console.log(signParams, 900001)
            this.signParams = signParams;
          }
          this.btnLoading = false;
        })
        .catch(() => {
          this.btnLoading = false;
        });
    },
    sendSig() {
      if (this.signParams && this.signParams.chainId) {
        let data = {
          rpcServer: this.rpcServerSelected,
          chainId: this.chainId.toString(),
          tx: this.signParams
        };
        console.log(data, 9929292992929929292)
        this.btnLoading = true;
        sendTxSig(data)
          .then(res => {
            const data2 = res["data"] || {};
            this.btnLoading = false;
            this.$message.success("提交成功！");
            this.checkResult({
              businessId: "1",
              url: data.rpcServer,
              chainId: data.chainId,
              hash: data2.hash
            });
          })
          .catch(() => {
            this.btnLoading = false;
            this.$message.warning("提交失败！");
          });
      } else {
        this.$message.error("请先生成sig后在进行该操作！");
      }
    },

    checkResult({ businessId, url, chainId, hash }) {
      this.pageLoading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let data = {
        businessId,
        url,
        chainId,
        hash
      };
      console.log("data", data);
      let that = this;
      this.interval = setInterval(() => {
        that.intervalTime += 1;
        if (that.intervalTime < 8) {
          sdkApi.getTxByHash(data).then(res => {
            const data = res["data"] || {};
            if (data.status == 1) {
              clearInterval(that.interval);
              that.interval = null;
              that.pageLoading.close();
              that.$message.success("发送成功！");
              that.getTransferList();
            }
          });
        } else {
          that.intervalTime = 0;
          clearInterval(that.interval);
          that.interval = null;
          that.pageLoading.close();
          that.$message.warning("发送失败,请重新生成sig！");
        }
      }, 1000);
    },

    getTransferList() {
      console.log("调用了getTransferList");
      this.tableLoading = true;
      let data = {
        type: "102",
        page: 1,
        rows: 10
      };
      transferList(data)
        .then(res => {
          this.tableLoading = false;
          const data = res["data"] || {};
          this.transferTableData = data.data || [];
        })
        .catch(() => {
          this.transferTableData = [];
          this.tableLoading = false;
        });
    },
      //查询哈希
    openHashSearch({ hash, rpcServer, fromChainId }) {
      this.hahsDialogVisible = true;
      const data = {
        hash,
        chainId: fromChainId,
        rpcServer
      };
      getTransactionByHash(data)
        .then(response => {
          this.returnHash = response.data;
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },
    downloadSdkDemo() {},
  }
};
</script>

<style lang="scss">
.sdk-docking {
  width: 95%;
  margin: 0 auto;
  text-align: left;
  height: 90vh;
  overflow-y: auto;
}

.item {
  margin-top: 20px;
  label {
    display: inline-block;
    width: 120px;
  }

  .item-input {
    width: 200px;
  }

  .item-btn {
    margin-left: 20px;
  }
}

.item-2 {
  display: inline-block;
  margin-top: 20px;
  margin-left: 40px;
  label {
    display: inline-block;
    width: 120px;
  }

  .item-input {
    width: 240px;
  }

  .item-btn {
    margin-left: 20px;
  }
}

.inline-block {
  display: inline-block;
  width: 800px;
  word-break: break-word;
}

.content {
  border: 1px solid #ccc;
  border-top: none;
  max-height: 300px;
  overflow: auto;
  /*.content-wrap {*/
  /*   display: none !important;*/
  /*   background-color: rebeccapurple;*/
  /*}*/
}

.layout {
  /*width: 1200px;*/
  /*margin: 0 auto;*/

  h1 {
    font-size: 26px;
    font-weight: 400;
    margin: 12px 0;
  }

  a {
    display: block;
    background-color: #f8f8f9;
    border-radius: 4px;
    padding: 8px 16px;
    border: 1px solid #edeff0;
    border-radius: 4px;
    margin-bottom: 20px;
    text-decoration: none;
    color: #2d8cf0;
  }

  .setting {
    border: 1px solid #ccc;
    padding: 10px 20px;

    h3 {
      line-height: 1.6;
      font-size: 18px;
      color: #333;
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;

    li {
      display: flex;
      align-items: center;
      padding: 10px 0;
      padding-right: 20px;
      label {
        font-size: 13px;
        padding-right: 10px;
        color: #333;
      }

      select {
        display: block;
        width: 80px;
        height: 28px;
        background: #fff;
      }
    }
  }
}

.caption {
  margin: 40px 0 10px;
  color: #333;
  font-size: 18px;
}
</style>
